<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-06-22 10:40:29
    Description : 
  -->
  <div class="card" @click="$emit('change', !checked)">
    <div>
      <img class="cover" :src="baseUrl + cover" />
      <div style="height: 0">
        <div class="checked" v-show="checked">
          <div class="check">
            <correct theme="filled" size="30" fill="#ffffff" />
          </div>
        </div>
      </div>
    </div>
    <div class="title">
      <div class="over" style="width: 97%">
        <el-popover
          placement="top-start"
          width="200"
          trigger="hover"
          :content="name"
        >
          <span slot="reference">{{ name }}</span>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { Correct } from "@icon-park/vue";
export default {
  components: {
    Correct,
  },
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    cover: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.over {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.card {
  display: inline-block;
  cursor: pointer;
}
.cover {
  width: 262px;
  height: 151px;
}
.title {
  width: 262px;
  height: 55px;
  margin-top: -4px;
  background: #ffffff;
  border-radius: 0 0 4px 4px;
  padding-top: 20px;
  padding-left: 10px;
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  color: #616161;
  box-sizing: border-box;
}
.checked {
  position: relative;
  top: -154px;
  left: 0;
  width: 262px;
  height: 151px;
  padding-top: 45px;
  background: rgba(0, 0, 0, 0.4);
  text-align: center;
  .check {
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    padding-top: 10px;
    background: #ff464c;
    opacity: 0.8;
  }
}
</style>